/** Mirrors `WARMING_CONFIG` in `functions/emailService.js` — keep in sync when changing server limits. */
export const WARMING_START_LIMIT = 50;
export const WARMING_DOUBLING_INTERVAL_DAYS = 3;
export const WARMING_MAX_DAYS = 30;
export const WARMING_CAP = 10000;

export function getWarmingLimit(day: number): number {
  if (day <= 0) return WARMING_START_LIMIT;
  const doublingCount = Math.floor((day - 1) / WARMING_DOUBLING_INTERVAL_DAYS);
  const limit = WARMING_START_LIMIT * Math.pow(2, doublingCount);
  return Math.min(limit, WARMING_CAP);
}

/** Appends guidance when the server rejects a send for domain warming limits. */
export function formatDomainWarmingHelpMessage(message: string): string {
  if (!message || typeof message !== 'string') return message;
  if (message.includes('Domain warming limit')) {
    return `${message} Split your audience, schedule the rest for a later UTC day, or review progress under Settings → Senders → Domains.`;
  }
  return message;
}

